import { useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

export function useFeedback() {
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState(null);

  const enviar = useCallback(async ({ tipo, mensagem }) => {
    setLoading(true);
    setErro(null);

    const { data: { user } } = await supabase.auth.getUser();

    const { error } = await supabase.from('feedback').insert({
      tipo,
      mensagem,
      user_id: user?.id ?? null,
    });

    setLoading(false);

    if (error) {
      console.error('useFeedback error:', error);
      setErro('Não foi possível enviar. Tente novamente.');
      return false;
    }

    setSucesso(true);
    return true;
  }, []);

  const resetar = useCallback(() => {
    setSucesso(false);
    setErro(null);
  }, []);

  return { enviar, loading, sucesso, erro, resetar };
}
